import {dbComun} from '../bases-datos'

export const ObtenerTiposDocumento = async () => {
  return Promise.resolve(dbComun.table('TiposDocumento').toArray())
}

export const ObtenerTiposDocumentoPorId = async (id) => {
  return Promise.resolve(dbComun.table('TiposDocumento').get({Id: id}))
}
